
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/who-we-help/investors-buyers",
      function () {
        return require("private-next-pages/who-we-help/investors-buyers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/who-we-help/investors-buyers"])
      });
    }
  